/**
 * Created by bootdo.
 * 用户相关api
 */
import * as API from './'

export default {
  // 登录
  login: params => {
    return API.POST(process.env.baseUserURL+'/auth/login', params)
  },

  // 登录后查询详情
  userInfo: params => {
    return API.POST(process.env.baseAccountURL+'/user/detail/token', params)
  },

}



// WEBPACK FOOTER //
// ./src/api/api_user.js